import createLetterSeed from '../hubLetterSeed/hubLetterSeed';

(function init() {
  angular.module('app').controller('host.views.debugTools.triggerHubUpdateCase.modal', [
    '$uibModalInstance',
    'abp.services.app.debugTool',
    function controller($uibModalInstance, debugToolSvc) {
      const vm = this;
      vm.saving = 0;
      vm.caseId = '';
      vm.status = '';
      vm.updatedCase = null;
      // Two-page modal: 'form' collects the payload, 'result' replaces it with the
      // confirmation; Back returns to the form with the entered values intact.
      // A rejected update keeps the operator on the form to correct it.
      // Status-only by design: the integration service drops every other field when a
      // status is present, so offering more inputs would silently discard them.
      vm.view = 'form';

      vm.statusOptions = ['Planned', 'Waitlist', 'Active', 'Finished', 'Cancelled'];

      // Seeding from a letter [HM-11245]: only the case, the one Hub Sync Repair's cancellation
      // updates. The status is always the engineer's to choose.
      vm.seed = createLetterSeed({
        caseId: { fromSeed: (v) => v || '', toInput: (v) => v },
      });
      vm.loadSeed = () =>
        vm.seed.load(vm, (input) => debugToolSvc.getHubUpdateCaseSeed(input));
      vm.resetSeed = () => vm.seed.reset(vm);

      vm.cancel = cancel;
      vm.execute = execute;
      vm.back = back;

      function cancel() {
        $uibModalInstance.dismiss();
      }

      function back() {
        vm.view = 'form';
      }

      function execute() {
        if (!App.isFormValid(vm.triggerHubUpdateCaseForm)) return;

        const input = { caseId: vm.caseId, status: vm.status };

        vm.saving += 1;
        vm.updatedCase = null;
        debugToolSvc
          .triggerHubUpdateCase(input)
          .success((result) => {
            if (result) {
              vm.updatedCase = {
                rows: [
                  { label: 'Hub case ID', value: vm.caseId },
                  { label: 'Status sent', value: vm.status },
                ],
              };
              vm.view = 'result';
              abp.notify.success('The Hub accepted the case update.');
            } else {
              abp.notify.error(
                'The Hub rejected the update. Check the case ID and values, then try again — the detail is in the server log.'
              );
            }
          })
          .finally(() => {
            vm.saving -= 1;
          });
      }
    },
  ]);
})();
